import ChatActionType from '../enums/action-types/ChatActionType';
import { globalConstants } from "../constants/globalConstants";
import UserActionType from '../enums/UserActionType';

const chooseAction = ({ scenarioResponse, data }) => {
    //TODO : improve this part
    if (!scenarioResponse && (data && (!data.userResponse && !data.actionType && !data.feedbackRequired && !data.isWelcomeComp))) {
        return { action: ChatActionType.INITIATE, payload: scenarioResponse };
        // return;
    }

    switch (true) {
        case _isCountrySelect(data):
            return { action: ChatActionType.COUNTRY_SELECT, payload: { ...data, ...scenarioResponse } }

        case _isCreateSrAction(data):
            return { action: ChatActionType.CREATE_SR, payload: { ...data, ...scenarioResponse } }

        case _isInitiateAction(scenarioResponse, data):
            return { action: ChatActionType.INITIATE, payload: scenarioResponse };

        // case _isFeedbackRequiredAction(data):
        //     return { action: ChatActionType.FEEDBACK_REQUIRED };
        case _isFeedbackAction(data):
            return { action: ChatActionType.FEEDBACK_ACTION, payload: { ...data } }
        case (data && data.isWelcomeComp):
            return { action: ChatActionType.SHOW_WELCOME_COMP };

        case (data && data.user_response && scenarioResponse && _isFreshIntent(data.user_response, scenarioResponse)):
            return { action: ChatActionType.CHAT_OUT, payload: { ...data, ...scenarioResponse } };

        case (data && data.user_response && scenarioResponse && _isLinkSetOnChoice(data.user_response, scenarioResponse)):
            return { action: ChatActionType.CHOICE_OPTION_LINK, payload: { ...data, ...scenarioResponse } };

        case (data && data.user_response && scenarioResponse && _isBookmarkedScenarioIdForChoice(data.user_response, scenarioResponse)):
            return { action: ChatActionType.BOOKMARK, payload: { ...data, ...scenarioResponse } };

        case _isUserResponseSubmitAction(data):
            return { action: ChatActionType.USER_RESPONSE, payload: data.userResponse };

        case _isChatInAction(scenarioResponse):
            return { action: ChatActionType.CHAT_IN, payload: { ...data, ...scenarioResponse } };

        case _isChatOutAction(scenarioResponse, data):
            return { action: ChatActionType.CHAT_OUT, payload: { ...data, ...scenarioResponse } };

        case _isInitiateRetryAction(scenarioResponse):
            return { action: ChatActionType.INITIATE_RETRY, payload: scenarioResponse };

        case _isAskForLoginAction(data):
            return { action: ChatActionType.ASK_FOR_LOGIN, payload: { ...data, ...scenarioResponse } };

        case _isAskForLoginAction(scenarioResponse):
            return { action: ChatActionType.ASK_FOR_LOGIN, payload: scenarioResponse };

        // case _isNoIntentFoundAction(scenarioResponse, scenarioList):
        //     return { action: ChatActionType.NO_INTENT_FOUND, payload: scenarioResponse };

        // case _isShowResponseAction(scenarioResponse):
        //     return { action: ChatActionType.SHOW_RESPONSE, payload: scenarioResponse };

        case _isShowDFFFormAction(scenarioResponse):
            return { action: ChatActionType.SHOW_DFF_FORM, payload: scenarioResponse };

        case _isShowDffCrmError(scenarioResponse):
            return { action: ChatActionType.SHOW_DFF_CRM_ERROR, payload: scenarioResponse };

        case _isShowDFFResponseAction(scenarioResponse):
            return { action: ChatActionType.SHOW_DFF_RESPONSE, payload: scenarioResponse };

        case _isInitiateWelcomeAction(data):
            return { action: ChatActionType.INITIATE, payload: scenarioResponse };

        case _isSmartSearchClicked(data):
            return { action: ChatActionType.CHAT_OUT, payload: { ...data, ...scenarioResponse } };

        case _isUserInputScenarioMismatch(scenarioResponse, data):
            return { action: ChatActionType.CHAT_OUT, payload: { ...data, ...scenarioResponse } };

        default:
            console.log('no action chosen')
            return { action: ChatActionType.NO_ACTION_CHOSEN };

    }

}


const _isCountrySelect = (data) => {
    return (data && data.actionType && data.actionType === globalConstants.USER_ACTION_TYPES.PLACE);
}

// const _isInitiateAction = (scenarioResponse, data) => {
//     return (scenarioResponse && scenarioResponse.initiate_after_login ?
//         scenarioResponse.initiate_after_login : scenarioResponse && scenarioResponse.isBookmarkedScenario ? scenarioResponse.isBookmarkedScenario :
//             (data && data.actionType && (data.actionType === "INITIATE" || data.actionType === globalConstants.USER_ACTION_TYPES.CHAT || data.actionType === globalConstants.USER_ACTION_TYPES.CATEGORY)));
// }

const _isInitiateAction = (scenarioResponse, data) => {
    if (
        (scenarioResponse && scenarioResponse.isBookmarkedScenario) ||
        (data && data.actionType && data.actionType === "INITIATE") ||
        (scenarioResponse && data && data.actionType && data.actionType === globalConstants.USER_ACTION_TYPES.CHAT) ||
        (scenarioResponse && data && data.actionType && data.actionType === globalConstants.USER_ACTION_TYPES.CATEGORY)) {
        return true
    }
    return false

}


const _isUserInputScenarioMismatch = (scenarioResponse, data) => {
    if (scenarioResponse && data && scenarioResponse.enteredText !== data.user_response) {
        return true
    }
    else
        return false
}

const _isUserResponseSubmitAction = (data) => {
    if (data && ("userResponse" in data) && data.userResponse)
        return true;
    else
        return false;
}

// const _isFeedbackRequiredAction = (data) => {
//
//     if (data && ("feedbackRequired" in data) && data.feedbackRequired)
//         return true;
//     else
//         return false;
// }
const _isFeedbackAction = (data) => {
    return (data && data.actionType === UserActionType.FEEDBACK_CLICK)
}

const _isInitiateRetryAction = (scenarioResponse) => {
    return (scenarioResponse && scenarioResponse.initiateRetry);
}

const _isAskForLoginAction = (data) => {
    return ((data && data.askForLogin) || (data && data.actionType && data.actionType === ChatActionType.ASK_FOR_LOGIN));
}

const _isCreateSrAction = (data) => {
    return (data && data.actionType && data.actionType === ChatActionType.CREATE_SR);
}

// const _isNoIntentFoundAction = (scenarioResponse, scenarioList) => {
//     return (scenarioResponse &&
//         scenarioResponse.scenario &&
//         (scenarioResponse.scenario.scenarioId === scenarioList["NO_INTENT_FOUND_1"].scenarioId
//             || scenarioResponse.scenario.scenarioId === scenarioList["NO_INTENT_FOUND_2"].scenarioId));
// }

const _isChatInAction = (scenarioResponse) => {
    return (scenarioResponse && scenarioResponse.scenarioActive);
}

const _isChatOutAction = (scenarioResponse, data) => {
    return (
        (scenarioResponse && ("scenarioActive" in scenarioResponse) && !scenarioResponse.scenarioActive) ||
        (data && data.actionType && data.actionType === globalConstants.USER_ACTION_TYPES.DEFAULT)
    );
}

const _isShowDFFFormAction = (scenarioResponse) => {
    return (scenarioResponse &&
        !scenarioResponse.scenarioActive &&
        scenarioResponse.dffStepResponse &&
        scenarioResponse.dffStepResponse.scenarioResponse &&
        scenarioResponse.dffStepResponse.scenarioResponse.length > 0);
}

const _isShowDffCrmError = (scenarioResponse) => {
    return (scenarioResponse &&
        !scenarioResponse.scenarioActive &&
        scenarioResponse.dffStepResponse &&
        scenarioResponse.dffStepResponse.statusCode &&
        scenarioResponse.dffStepResponse.statusCode ===
        "CRM_CONSUME_SR_API_ERROR");
}

const _isShowDFFResponseAction = (scenarioResponse) => {
    return (scenarioResponse &&
        !scenarioResponse.scenarioActive &&
        scenarioResponse.dffStepResponse &&
        scenarioResponse.dffStepResponse.status &&
        scenarioResponse.dffStepResponse.status.statusCode &&
        scenarioResponse.dffStepResponse.status.statusCode === "success");
}

const _isInitiateWelcomeAction = (data) => {
    return (data && ("isUserLoggedIn" in data) && (data.isUserLoggedIn === false || data.isUserLoggedIn === true));
}


// smart search and category option click for both ----
//TODO improve name
const _isSmartSearchClicked = (data) => {
    return (data && (data.actionType === globalConstants.USER_ACTION_TYPES.CHAT || data.actionType === globalConstants.USER_ACTION_TYPES.CATEGORY));
}

const _isFreshIntent = (enteredText, result) => {
    const ScenarioObject = result.scenario;
    if (
        ScenarioObject &&
        ScenarioObject["scenarioStep"] &&
        ScenarioObject["scenarioStep"]["options"] &&
        ScenarioObject["scenarioStep"]["options"].length
    ) {
        for (
            let i = 0;
            i < ScenarioObject["scenarioStep"]["options"].length;
            i++
        ) {
            if (
                ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase() ===
                enteredText.toUpperCase() &&
                ScenarioObject["scenarioStep"]["options"][i]["freshIntent"] &&
                ScenarioObject["scenarioStep"]["options"][i]["freshIntent"] === true
            ) {
                return true
            }
        }
    }
    return false;
}

const _isLinkSetOnChoice = (enteredText, result) => {
    const ScenarioObject = result.scenario;
    if (
        ScenarioObject &&
        ScenarioObject["scenarioStep"] &&
        ScenarioObject["scenarioStep"]["options"] &&
        ScenarioObject["scenarioStep"]["options"].length
    ) {
        for (
            let i = 0;
            i < ScenarioObject["scenarioStep"]["options"].length;
            i++
        ) {
            if (
                ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase() ===
                enteredText.toUpperCase() &&
                ScenarioObject["scenarioStep"]["options"][i]["stepLink"]
            ) {
                return true;
            }
        }
    }
    return false;
}

const _isBookmarkedScenarioIdForChoice = (enteredText, result) => {
    const ScenarioObject = result.scenario;
    if (
        ScenarioObject &&
        ScenarioObject["scenarioStep"] &&
        ScenarioObject["scenarioStep"]["options"] &&
        ScenarioObject["scenarioStep"]["options"].length
    ) {
        for (
            let i = 0;
            i < ScenarioObject["scenarioStep"]["options"].length;
            i++
        ) {
            if (
                ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase() ===
                enteredText.toUpperCase() &&
                ScenarioObject["scenarioStep"]["options"][i]["bookMark"] &&
                ScenarioObject["scenarioStep"]["options"][i]["bookMark"][
                "scenarioId"
                ]
            ) {
                return true;
            }
        }
    }
    return false;
};

export {
    chooseAction
};


// WEBPACK FOOTER //
// ./src/actions/chooseAction.js